import { render } from "./ProviderEditHeader.vue?vue&type=template&id=43365361"
import script from "./ProviderEditHeader.vue?vue&type=script&lang=js"
export * from "./ProviderEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__